import bem from 'utils/bem';

export const block = bem('billing-cycle-modal');
